<template>
<div style="background-color: #e5e3e9;display: flex; flex-direction: column;width: 100%;height: 100%;overflow: auto">
  <div style="background-color: white;border: 1px solid #000;width: 800px; margin: 0 auto;text-align: center;padding: 5px">
    <div style="font-size: 36px;display: inline-block;padding: 15px">产 品 购 买 合 同</div>
    <div style="text-align: right;font-size: 18px">合同编号：{{this.contractData.contractNo}}</div>

    <div style="display: flex" v-if="buttonShow">
      <el-select style="width:50%" v-model="company_id" placeholder="选择公司"
                 filterable remote :remote-method="getCompanyByRemote"  @change="getChance()">
        <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select style="width:50%;margin-left: 10px" v-model="chance_id" placeholder="选择机会编号" @change="getAllInfo">
        <el-option v-for="item in chanceList" :key="item.id" :label="item.id" :value="item.id" ></el-option>
      </el-select>
    </div>

    <el-form :model="contractData.partyA" label-width="150px" label-position="left" style="padding: 20px 0 0 22px">
      <el-form-item label="甲方（需方）: " label-width="110px" style="margin-bottom: 0;padding: 1px" required>
        <el-input v-model="contractData.partyA.name" :disabled="!buttonShow" style="width: 305px" />
      </el-form-item>
      <el-form-item label="法定代表人或代理人：" label-width="162px" style="margin-bottom: 0;padding: 1px" required>
        <el-input v-model="contractData.partyA.representative" :disabled="!buttonShow" style="width: 80px" />
      </el-form-item>
      <el-form-item label="地址：" label-width="64px" style="margin-bottom: 0;padding: 1px" required>
        <el-select style="width: 100%" class="contactSelect" v-model="contractData.partyA.address" :disabled="!buttonShow" placeholder="选择地址"
                   filterable="true">
          <el-option v-for="item in companyAddress" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人：" label-width="78px" style="margin-bottom: 0;padding: 1px" required>
        <el-select v-model="contractData.partyA.contact_id" :disabled="!buttonShow" @change="this.getContactPhone(contactsList,contractData.partyA.contact_id)" placeholder="请选择" clearable filterable style="width: 100px">
          <el-option v-for="item in contactsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话：" label-width="92px" style="margin-bottom: 0;padding: 1px" required>
        <el-select class="contactSelect" v-model="contractData.partyA.telephone_id" :disabled="!buttonShow" placeholder="选择联系电话" clearable="true"
                   filterable="true">
          <el-option v-for="item in contactPhones" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-form :model="contractData.partyB" label-width="150px" label-position="left" style="padding: 20px 0 0 22px">
      <el-form-item label="乙方（供方）: " label-width="110px" style="margin-bottom: 0;padding: 1px" required>
<!--        <el-input v-model="contractData.partyB.name" style="width: 255px" />-->
        <el-select v-model="contractData.partyB.name" :disabled="!buttonShow" @change="partyBHandleSelectChange" placeholder="请选择" clearable filterable style="width: 255px">
          <el-option v-for="item in joySunCompanyList" :key="item.name" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="法定代表人或代理人：" label-width="162px" style="margin-bottom: 0;padding: 1px" required>
        <el-input v-model="contractData.partyB.representative" :disabled="!buttonShow" style="width: 80px" />
      </el-form-item>
      <el-form-item label="地址：" label-width="64px" style="margin-bottom: 0;padding: 1px" required>
        <el-input v-model="contractData.partyB.address" :disabled="!buttonShow" style="width: 100%" />
      </el-form-item>
      <el-form-item label="联系人：" label-width="78px" style="margin-bottom: 0;padding: 1px" required>
<!--        <el-input v-model="contractData.partyB.contacts" style="width: 100px" />-->
        <el-select v-model="contractData.partyB.contacts" :disabled="!buttonShow" @change="partyBContactsHandleSelectChange" placeholder="请选择" clearable filterable style="width: 100px">
          <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.full_name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话：" label-width="92px" style="margin-bottom: 0;padding: 1px" required>
        <el-input v-model="contractData.partyB.telephone" :disabled="!buttonShow" style="width: 270px" />
      </el-form-item>
    </el-form>

    <div style="text-align: left;padding: 40px 0 0 0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为维护各自的合法权益，甲、乙双方根据《中华人民共和国民法典》及相关法律法规规定，本着平等互利、诚实守信的原则，经友好协商，就甲方从乙方处购买产品等合作事宜，一致同意签订本框架合同，共同遵守。</div>

    <div style="text-align: left;">
      <div class="container">
        <el-select v-model="contractData.quote.quoteNo" :disabled="!buttonShow" @change="quoteHandleSelectChange" placeholder="请选择" clearable filterable style="width: 200px;">
          <el-option v-for="item in quoteList" :key="item.id" :label="item.quote_no" :value="item.quote_no"></el-option>
        </el-select>
        <p>货币单位：人民币</p>
      </div>
      <el-table :data="contractData.quote.items" stripe border style="width: 100%;">
        <el-table-column type="index" label="序号" min-width="7" />
        <el-table-column prop="product_name" label="产品名称" min-width="30" />
        <el-table-column prop="cnt" label="数量" min-width="10" />
        <el-table-column prop="sales_price" label="单价" min-width="15" />
        <el-table-column prop="tax_rate" label="税率" min-width="10" />
        <el-table-column prop="price" label="小计" min-width="15" />
        <el-table-column prop="remark" label="备注" min-width="10" />
      </el-table>
      <div style="border: 1px solid #ebeef5;">
        <el-row>
          <el-col :span="2"></el-col>
          <el-col :span="16">
            <div style="border-left: 1px solid #ebeef5;border-right: 1px solid #ebeef5;font-weight: bold;">
              含税总金额（大写：{{this.contractData.quote.totalAmountCapital}}）
            </div>
          </el-col>
          <el-col :span="6">
            <div style="font-weight: bold;padding: 0 0 0 9px">
              {{this.contractData.quote.totalAmount}}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div style="text-align: left;padding: 20px 0 0 22px">
      <p style="font-weight: bold;">二、条款与说明</p>
      <p>1、本合同<span style="color: crimson">*</span>最终用户为：
        <el-input v-model="contractData.company" :disabled="!buttonShow" style="width: 590px" />
        ，Account name:<el-input v-model="contractData.companyEn" :disabled="!buttonShow" style="width: 650px" /> 。
        <span style="color: crimson">*</span>实际使用地为
        <el-select style="width: 654px" class="contactSelect" v-model="contractData.address" :disabled="!buttonShow" placeholder="选择地址"
                   filterable="true" @change="getAddressEn">
          <el-option v-for="item in companyAddress" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        ，address:<el-input v-model="contractData.addressEn" :disabled="!buttonShow" style="width: 694px" /> ，
        如甲方根据实际情况需要对软件许可地发生变更，应通知乙方，乙方需配合甲方完成软件许可转移操作，以保证软件许可的使用合规。
      </p>
      <p style="font-weight: bold;">2、付款条件：</p>
<!--      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合同签订生效并收到乙方开具的准确无误的所应付金额对应的全额增值税发票后5日内甲方向乙方转账支付合同总金额的-->
<!--        <el-input v-model="contractData.paymentTerms.proportion" style="width: 40px" />-->
<!--        首付款（预付款）共计-->
<!--        <el-input v-model="contractData.paymentTerms.first" style="width: 150px" />-->
<!--        元，软件安装并验收（验收标准参考合同附件）后10日内需方向供方支付剩余合同价款，即甲方向乙方支付剩余尾款共计-->
<!--        <el-input v-model="contractData.paymentTerms.rest" style="width: 150px" />-->
<!--        元，若甲方因其自身原因不予签署验收确认单，产品由供方交付给需方后3日内需方未提出意见视为验收合格。若甲方未收到乙方开具的准确无误的应支付款项对应的全额发票，-->
<!--        甲方有权不支付款直到收到正确的发票，并不负任何责任；若甲方拒收发票，拒收发票当天视为乙方完成了发票开具的义务，以拒收发票所在日期的第二天起算付款条件成就的截止时间，甲方不得以未收到乙方发票拒付款项。-->
<!--      </p>-->
      <p>
        <el-input
            v-model="contractData.paymentTerms"
            autosize
            type="textarea"
            placeholder=" "
        />
      </p>
      <p style="font-weight: bold;">3、产品交付时间及地点：</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;乙方收到甲方首付款后的15个工作日内交付安装，交货地点由甲方指定（软件支持降版本安装，但甲方需保证硬件及操作系统支持当前版本的安装条件），<span style="color: crimson">*</span>乙方指定软件交接人：
        <el-select v-model="contractData.handoverPerson.name" @change="handoverPersonHandleSelectChange" placeholder="请选择" clearable filterable style="width: 100px">
          <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.full_name"></el-option>
        </el-select>，<span style="color: crimson">*</span>联系方式：
        <el-input v-model="contractData.handoverPerson.telephone" style="width: 180px" />。
      </p>
      <p style="font-weight: bold;">4、乙方提供维护升级服务内容说明</p>
      <p style="padding: 0 0 0 22px">
        1）	SolidWorks软件维护期内免费升级服务；<br>
        2）	SolidWorks软件维护期内最新版本光盘的免费提供；<br>
        3）	维护期内技术服务：电话、邮件、传真、现场对应（周一至周五9:00~18:00）；<br>
        4）	保证甲方获取资源库的访问权限。该资源库基于Web，包含大量有深度的信息和有价值的资源；<br>
        5）	服务请求(SR)—向技术支持人员提交事件报告，以获得快速解决；<br>
        6）	知识库—在库中使用专用搜索引擎搜索技术文档库，找到相关问题的解决方案；<br>
        7）	相关认证考试CSWP/CSWA考试。该考试旨在确保您的设计团队能够充分利用产品的各项优势；<br>
        8）	甲方有权参加SolidWorks全球用户大会暨博览会及年度用户大会，以了解最新的产品和服务。<br>
        以上1）、2）、3）点中： 乙方应在收到甲方书面通知后1个工作日内及时回复并提供相应服务；如相关问题在3个工作日内仍无法解决的，乙方须提供现场应对服务，其产生的费用由乙方自行承担。
      </p>
      <p style="font-weight: bold;">5、不可抗力：</p>
      <p style="padding: 0 0 0 22px">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“不可抗力”指超出本合同双方控制范围、无法预见、无法避免或无法克服、使得本合同一方部分或者完全
        不能履行本合同的事件。此类事件包括但不限于地震、 台风、洪水、火灾、战争、罢工、暴动、政府行为、法律规定或其适用的变化，或者其他任何无法预见、
        避免或者控制的时间，包括在国际商务实践中通常被认 定为不可抗力的事件。双方的任何一方由于不可抗力的原因不能履行合同时，应及时以书面形式向对方
        通报不能履行或不能完全履行的理由，并应在15日内提供 有关主管部门的证明。经双方书面确认后，本合同履行期限予以顺延。
      </p>
      <div>
        <div class="left">
          6、
        </div>
        <div class="right">
          <strong>保密义务：</strong>本合同订立前以及在本合同期限内，甲乙双方曾经或者可能不时向对方披露有关产品的保密资料。在本合同期限内以及合同终止后2年内，甲乙双方必须：<br>
          1）对保密资料进行保密；<br>
          2）不为除合同明确规定的目的之外的其他目的使用保密资料；<br>
          3）除为履行其职责而确有必要知悉保密资料的该方或其关联机构雇员、该方律师、会计师或其他顾问外，不向其他任何人披露。
        </div>
      </div>
      <p style="font-weight: bold;">7、违约责任：</p>
      <p style="padding: 0 0 0 22px">
        1）如甲方逾期付款的，每逾期一日，须按本期应付未付金额的万分之两点五向乙方承担违约金，该项累计不超过逾期支付金额的30%。合同签订后，甲方
        逾期5日未支付合同所约定的首付款，乙方有权选择单方解除本合同，同时甲方需要承担合同总款项30%的违约金。乙方在按照合同约定向甲方交付软件产品，
        甲方不予回复、对接或是拒绝对接安装工作的，乙方的交付安装通知（包括但不限于微信、邮件、书面方式）到达甲方授权联系人之日起5日内视为完成
        合同义务，并以此计算合同剩余尾款应支付的成就时间，甲方应予以支付相应的合同价款。<br>
        2）如甲方错填送货地、运达地或甲方指定的接货单位（人），从而导致乙方支付额外运费的，所有的额外运费由甲方承担。<br>
        3）如乙方提供的货品型号、数量、外观等不符合合同约定，视为乙方违约，甲方有权拒绝接收货品，乙方须赔偿甲方由此造成的所有损失；
        如甲方无正当理由拒绝接收符合合同约定产品的，视为甲方违约，甲方应赔偿乙方由此造成的所有损失。<br>
        4）如乙方逾期交货或逾期安装或逾期提供相关服务的，或交货不符合合同约定而延误交货时间的，每逾期或延误一日，需按合同金额的万分之两点五向甲方承担违约金。<br>
        5）本合同约定违约方应赔付的违约金及其它经济损失，应在非违约方向违约方发出通知后15日内违约方进行支付。<br>
        6）乙方保证本合同项下的产品不存在任何权利瑕疵（包括但不限于所有权、知识产权等），如存在权利瑕疵，甲方有权解除合同，乙方应赔偿甲方双倍合同
        总价款及承担甲方所有损失（该损失包括但限于第三方向甲方的索赔、甲方因此诉讼仲裁的费用、保全费、鉴定费、律师费、差旅费、交通费等所有相关费用）。
        同时，甲方保证按照本合同项下的约定支付款项，如甲方违反本协议中的保证、承诺或其他约定和/或法定义务即构成违约，甲方亦应当承担因此产生的所有责任
        并赔偿因此给乙方造成的所有损失，包括但不限律师费、公证费、调查费、鉴定费、诉讼费、保全费、差旅费、通讯费等实现债权的合理费用。<br>
        7）保密责任：一方对于知悉对方未披露的任何信息或秘密承担保密义务。如一方泄密的，违约方应向对方赔偿因此产生的经济损失，但赔偿金额不超过实际损失
        的30%。同时违约方应支付守约方其他相关损失（该损失包括但限于第三方向甲方的索赔、守约方因此诉讼仲裁的费用、保全费、鉴定费、律师费、差旅费、交通费等所有相关费用）。
      </p>
      <p style="font-weight: bold;">8、联系方式及通知</p>
      <p style="padding: 0 0 0 22px">1）、为更好的履行本合同，包括但不限于合同、发票等的对接，产品交付安装等，双方授权联系人及联系方式：<br>
        （1）甲方授权联系人和联系方式：<br>
        <span style="color: crimson">*</span>联系人：
        <el-select v-model="contractData.contactInformation.partyA.contact_id" :disabled="!buttonShow" @change="contactInformationHandleSelectChange" placeholder="请选择" clearable filterable style="width: 100px">
          <el-option v-for="item in contactsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select><br>
        <span style="color: crimson">*</span>邮寄地址：<el-input v-model="contractData.contactInformation.partyA.address" :disabled="!buttonShow" style="width: 660px" /><br>
        <span style="color: crimson">*</span>联系电话：
        <el-select class="contactSelect" v-model="contractData.contactInformation.partyA.telephone_id" :disabled="!buttonShow" placeholder="选择联系电话" clearable="true"
                   filterable="true">
          <el-option v-for="item in contactPhonesA" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <br>
        <span style="color: crimson">*</span>电子邮箱：<el-input v-model="contractData.contactInformation.partyA.mail" :disabled="!buttonShow" style="width: 200px" /><br>
        微信号：<el-input v-model="contractData.contactInformation.partyA.weChat" :disabled="!buttonShow" style="width: 200px" /><br>
        （2）乙方授权联系人和联系方式：<br>
        <span style="color: crimson">*</span>联系人：
        <el-select v-model="contractData.contactInformation.partyB.name" :disabled="!buttonShow" @change="contactInformationBHandleSelectChange" placeholder="请选择" clearable filterable style="width: 100px">
          <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.full_name"></el-option>
        </el-select><br>
        <span style="color: crimson">*</span>邮寄地址：<el-input v-model="contractData.contactInformation.partyB.address" :disabled="!buttonShow" style="width: 660px" /><br>
        <span style="color: crimson">*</span>联系电话：<el-input v-model="contractData.contactInformation.partyB.telephone" :disabled="!buttonShow" style="width: 200px" /><br>
        <span style="color: crimson">*</span>电子邮箱：<el-input v-model="contractData.contactInformation.partyB.mail" :disabled="!buttonShow" style="width: 200px" /><br>
        微信号：<el-input v-model="contractData.contactInformation.partyB.weChat" :disabled="!buttonShow" style="width: 200px" /><br>
        2）双方通过上述联系方式之任何一种（包括电子邮箱、微信），就本合同有关事项向对方发送相关通知等，均视为有效送达与告知对方，无论对方是否实际查阅。上述邮寄送达地址同时作为有效司法送达地址。<br>
        3）一方变更通知或通讯地址，应自变更之日起三日内，以书面形式通知对方；否则，由未通知方承担由此而引起的相关责任。
      </p>
      <p style="font-weight: bold;">9、开票资料与收账账户：</p>
      <p style="padding: 0 0 0 22px">
        1）甲方确认开票资料如下：<br>
        <span style="color: crimson">*</span>名称：<el-input v-model="contractData.invoicing.name" :disabled="!buttonShow" style="width: 320px" /><br>
        <span style="color: crimson">*</span>税号：<el-input v-model="contractData.invoicing.dutyParagraph" :disabled="!buttonShow" style="width: 250px" /><br>
        <span style="color: crimson">*</span>地址：<el-input v-model="contractData.invoicing.address" :disabled="!buttonShow" style="width: 690px" /><br>
        <span style="color: crimson">*</span>开户银行：<el-input v-model="contractData.invoicing.bank" :disabled="!buttonShow" style="width: 350px" /><br>
        <span style="color: crimson">*</span>银行账户：<el-input v-model="contractData.invoicing.bankAccount" :disabled="!buttonShow" style="width: 250px" /><br>
        2）乙方确认的收款账户如下：<br>
        <span style="color: crimson">*</span>开户名：<el-input v-model="contractData.collection.name" :disabled="!buttonShow" style="width: 250px" /><br>
        <span style="color: crimson">*</span>开户银行：<el-input v-model="contractData.collection.bank" :disabled="!buttonShow" style="width: 350px" /><br>
        <span style="color: crimson">*</span>银行账户：<el-input v-model="contractData.collection.bankAccount" :disabled="!buttonShow" style="width: 250px" /><br>
      </p>
      <p style="font-weight: bold;">10、争议解决：</p>
      <p style="padding: 0 0 0 22px">
        如果发生由本合同（或其违反、终止或者无效）引起或者与其相关的争议、纠纷或者索赔（统称“争议”），双方首先应争取通过友好协商来解决，如协商不成，双方同意提交甲方所在地人民法院进行裁决。
      </p>
      <p><strong>11、合同生效：</strong>双方选择合同生效于<span style="color: crimson">*</span>（
        <el-select v-model="contractData.contactSelect" :disabled="!buttonShow" placeholder=" " clearable filterable style="width: 60px">
          <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        ）：
      </p>
      <p style="padding: 0 0 0 22px">
        a)	甲方交付服务费之日；<br>
        b)	合同签订之日。
      </p>
      <p><strong>12、其他：</strong>双方约定传真件及扫描件有效。本合同原件一式两份，甲、乙双方各持一份，具有同等法律效力。本合同如有未尽事宜，
        由双方另行签订补充协议，补充协议与本同具有同等法律效力。</p>
      <div style="padding: 20px">
        <div style="float: left;width: 50%">
          <p><span style="color: crimson">*</span>甲方（盖章： ）：{{this.contractData.partyA.name}}</p><br>
          <p>法人代表：
            <el-input v-model="contractData.partyA.representative1" :disabled="!buttonShow" style="width: 150px" />
          </p><br>
          <p>授权代表：
            <el-select v-model="contractData.partyA.authorizedRepresentative" :disabled="!buttonShow" @change="contactsHandleSelectChange" placeholder="请选择" clearable filterable style="width: 100px">
              <el-option v-for="item in contactsList" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </p><br>
          <p>签订日期：
            <el-input v-model="contractData.partyA.date" style="width: 150px" />
          </p>
        </div>
        <div style="float: left;width: 50%">
          <p><span style="color: crimson">*</span>乙方（盖章：）：{{this.contractData.partyB.name}}</p><br>
          <p>法人代表：
            <el-input v-model="contractData.partyB.representative1" :disabled="!buttonShow" style="width: 150px" />
          </p><br>
          <p>授权代表：
            <el-select v-model="contractData.partyB.authorizedRepresentative" :disabled="!buttonShow" placeholder="请选择" clearable filterable style="width: 100px">
              <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.full_name"></el-option>
            </el-select>
          </p><br>
          <p>签订日期：
            <el-input v-model="contractData.partyB.date" :disabled="!buttonShow" style="width: 150px" />
          </p>
        </div>
      </div>

      <div style="display: flex; justify-content: center; margin-top: 220px;">
        <el-button v-if="!this.parentData.content_json" @click="createContract" :loading="loading" type="primary">创建</el-button>
      </div>

    </div>

  </div>
</div>
  <el-watermark :gap="[200,200]" :font="font" :content="content" style="position:unset;height: 100%;width: 100%">
  </el-watermark>
</template>

<script>
export default {
  name: "MakeContract1",
  i18n: {},
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return{
      contractData: {
        contractNo: 'JOYS-PRM-****',
        partyA: {
          name: "",
          representative: "",
          address: "",
          contacts: "",
          telephone: "",
          authorizedRepresentative: "",
          date: "",
          representative1: ""
        },
        partyB: {
          name: "",
          representative: "",
          address: "",
          contacts: "",
          telephone: "",
          authorizedRepresentative: "",
          date: "",
          representative1: ""
        },
        quote:{
          quoteNo:"",
          items: [],
          totalAmountCapital: "",
          totalAmount: "",
        },
        company: "",
        companyEn: "",
        address: "",
        addressEn: "",
        paymentTerms: "合同签订生效并收到乙方开具的准确无误的所应付金额对应的全额增值税发票后5日内甲方向乙方转账支付合同总金额的50%首付款（预付款）共计***元，软件安装并验收（验收标准参考合同附件）后10日内需方向供方支付剩余合同价款，即甲方向乙方支付剩余尾款共计***元，若甲方因其自身原因不予签署验收确认单，产品由供方交付给需方后3日内需方未提出意见视为验收合格。若甲方未收到乙方开具的准确无误的应支付款项对应的全额发票，甲方有权不支付款直到收到正确的发票，并不负任何责任；若甲方拒收发票，拒收发票当天视为乙方完成了发票开具的义务，以拒收发票所在日期的第二天起算付款条件成就的截止时间，甲方不得以未收到乙方发票拒付款项。",
        handoverPerson: {
          name: "",
          telephone: ""
        },
        contactInformation: {
          partyA: {
            name: "",
            address: "",
            telephone: "",
            mail: "",
            weChat: ""
          },
          partyB: {
            name: "",
            address: "",
            telephone: "",
            mail: "",
            weChat: ""
          }
        },
        invoicing: {
          name: "",
          dutyParagraph: "",
          address: "",
          bank: "",
          bankAccount: ""
        },
        collection: {
          name: "",
          bank: "",
          bankAccount: ""
        },
        contactSelect:""

      },
      companyList:[],
      companyAllList:[],
      chanceDetailList:[],
      company_id:'',
      chance_id:'',
      chanceList:[],
      contactPhones:[],
      contactPhonesA:[],
      companyAddress:[],
      contactsList:[],
      joySunCompanyList: [],
      currentUserInfo: {},
      quoteList: [],
      userList: [],
      allUserList: [],
      selectList:[
        {
          value: "a",
          label: "a"
        },
        {
          value: "b",
          label: "b"
        }
      ],
      loading: false,
      url:"",
      buttonShow:true,
      font:{
        color: '#d6d5d5'
      },
      content:"JOYSUN"

    }
  },
  methods:{
    async getFileUrl() {
      let object = await this.$http('crmService.getFile', this.parentData)
      this.url = object.url
    },
    async getContactByChanceId(chanceId){
      let params = {chance_id:chanceId}
      let object =  await this.$http('crmContractService.getCompanyByChanceId',params)
      this.contactsList = object.companyContactList;
      if(this.parentData.content_json){
        return;
      }
      this.contractData.partyA.name = object.companyName
      this.contractData.partyA.representative = object.legalRepresentative
      this.contractData.partyA.representative1 = object.legalRepresentative
      this.contractData.partyA.address = object.companyAddress
      this.contractData.company = object.companyName
      this.contractData.address = object.companyAddress
      this.contractData.companyEn = object.companyNameEn
      this.contractData.addressEn = object.companyAddressEn
      this.contractData.contactInformation.partyA.address = object.companyAddress
      this.contractData.invoicing.name = object.companyName
      this.contractData.invoicing.address = object.companyAddress
      this.contractData.invoicing.dutyParagraph = object.dutyParagraph
      let address1 = {
        id:object.companyAddressRegister,
        name:object.companyAddressRegister,
        nameEn:object.companyAddressRegisterEn,
      }
      let address2 = {
        id:object.companyAddress,
        name:object.companyAddress,
        nameEn:object.companyAddressEn,
      }
      if(address1.name){
        this.companyAddress.push(address1)
      }
      if(address2.name){
        this.companyAddress.push(address2)
      }
    },
    async getCurrentUserInfo(){
      let object =  await this.$http('crmContractService.getCurrentUserInfo',this.parentData)
      this.currentUserInfo = object
      this.contractData.partyB.contacts = object.full_name
      this.contractData.partyB.telephone = object.mobile
      this.contractData.handoverPerson.name = object.full_name
      this.contractData.handoverPerson.telephone = object.mobile
      this.contractData.contactInformation.partyB.name = object.full_name
      this.contractData.contactInformation.partyB.telephone = object.mobile
      this.contractData.contactInformation.partyB.mail = object.email
    },
    async getQuoteByChanceId(chanceId){
      let params = {chance_id:chanceId}
      let list =  await this.$http('crmContractService.getQuoteByChanceId',params)
      this.quoteList = list
      this.contractData.quote.quoteNo = list[0].quote_no
      this.quoteHandleSelectChange(this.contractData.quote.quoteNo)
    },
    async getUser(){
      let list =  await this.$http('crmContractService.getUser')
      this.userList = list
    },
    async getUserAll(){
      let list =  await this.$http('crmContractService.getUserAll')
      this.allUserList = list
    },
    async getSysCompany(){
      let list =  await this.$http('crmContractService.getSysCompany')
      this.joySunCompanyList = list
    },
    async createContract(){
      this.loading = true
      console.log(this.contractData)
      if (this.contractData.partyA.name === "" || this.contractData.partyA.representative === ""
          || this.contractData.partyA.address === "" || this.contractData.partyA.contacts === ""
          || this.contractData.partyA.telephone === "" || this.contractData.partyB.name === ""
          || this.contractData.partyB.representative === "" || this.contractData.partyB.address === ""
          || this.contractData.partyB.contacts === "" || this.contractData.partyB.telephone === ""
          || this.contractData.company === "" || this.contractData.companyEn === ""
          || this.contractData.address === "" || this.contractData.addressEn === ""
          || this.contractData.paymentTerms === "" || this.contractData.handoverPerson.name === ""
          || this.contractData.handoverPerson.telephone === "" || this.contractData.contactInformation.partyA.name === ""
          || this.contractData.contactInformation.partyA.address === "" || this.contractData.contactInformation.partyA.telephone === ""
          || this.contractData.contactInformation.partyA.mail === "" || this.contractData.contactInformation.partyB.name === ""
          || this.contractData.contactInformation.partyB.address === "" || this.contractData.contactInformation.partyB.telephone === ""
          || this.contractData.contactInformation.partyB.mail === "" || this.contractData.invoicing.name === ""
          || this.contractData.invoicing.dutyParagraph === "" || this.contractData.invoicing.address === ""
          || this.contractData.invoicing.bank === "" || this.contractData.invoicing.bankAccount === ""
          || this.contractData.collection.name === "" || this.contractData.collection.bank === ""
          || this.contractData.collection.bankAccount === "" || this.contractData.contactSelect === ""){
        this.loading = false
        return this.$message.error("存在未填写的必填项，请检查填写后重新提交！");
      }
      this.contractData.chance_id = this.chance_id;

      await this.$http('crmContractService.createContract',this.contractData)
      this.loading = false
      // if (object.url) {
      //   let name = object.original_name
      //
      //   const a = document.createElement('a')
      //   fetch(object.url).then(res => res.blob()).then(blob => {
      //     a.href = URL.createObjectURL(blob)
      //     a.download = name || '' // 下载文件的名字
      //     document.body.appendChild(a)
      //     a.click()
      //
      //     //在资源下载完成后 清除 占用的缓存资源
      //     window.URL.revokeObjectURL(a.href);
      //     document.body.removeChild(a);
      //   })
      //
      // }
      this.$message.success("创建成功")
      this.$fn.closeWindow();
      this.$fn.search();
    },

    getAddressEn(){
      this.companyAddress.forEach((item) => {
        if (item.id === this.contractData.address){
          this.contractData.addressEn = item.nameEn
        }
      })
    },
    //根据关键字带出公司
    getCompanyByRemote(value){
      if(value){
        this.companyList = [];
        for (let i = 0; i < this.companyAllList.length; i++) {
          let item = this.companyAllList[i]
          if(item && item.name && item.name.trim() !== ''){
            let name = item.name.toLowerCase();
            value = value.toLowerCase();
            if(name.includes(value)){
              this.companyList.push(item)
            }
          }
        }
      }else {
        this.companyList = []
      }
    },

    //根据公司 获取机会List
    getChance(){
      if(this.chanceDetailList){
        for(let item of this.chanceDetailList){
          if(item){
            if(item.company_id === this.company_id){
              this.chanceList.push(item);
            }
          }
        }
      }

    },

    //获取当前登陆人所相关的所有公司，以及公司下的机会和机会下的潜力产品
    async getUserCompanyList() {
      let data = await this.$http('crmQuoteService.getCompanyByUser');
      this.companyAllList = data.companyInfoList;
      this.chanceDetailList = data.chanceList;
      //this.potentialInfoList = data.potentialInfoList;
    },

    getAllInfo(){
      if(this.chance_id){
        this.getContactByChanceId(this.chance_id)
        this.getQuoteByChanceId(this.chance_id)

      }
    },

    contactsHandleSelectChange(value) {
      const selectedOption = this.contactsList.find(option => option.name === value);
      let phones = JSON.parse(selectedOption.phones);
      if(phones.length > 0){
        this.contractData.partyA.telephone = phones[0].phone;  // 根据选中的值来设置el-input的值
      }
    },
    partyBHandleSelectChange(value) {
      const selectedOption = this.joySunCompanyList.find(option => option.name === value);
      this.contractData.partyB.representative = selectedOption.legal_person;
      this.contractData.partyB.representative1 = selectedOption.legal_person;
      this.contractData.partyB.address = selectedOption.address;
      this.contractData.contactInformation.partyB.address = selectedOption.address;
      this.contractData.collection.name = selectedOption.account_name;
      this.contractData.collection.bank = selectedOption.bank_name;
      this.contractData.collection.bankAccount = selectedOption.account_number;
    },
    partyBContactsHandleSelectChange(value){
      const selectedOption = this.userList.find(option => option.full_name === value);
      this.contractData.partyB.telephone = selectedOption.mobile
    },
    handoverPersonHandleSelectChange(value){
      const selectedOption = this.userList.find(option => option.full_name === value);
      this.contractData.handoverPerson.telephone = selectedOption.mobile
    },
    contactInformationBHandleSelectChange(value){
      const selectedOption = this.userList.find(option => option.full_name === value);
      this.contractData.contactInformation.partyB.telephone = selectedOption.mobile
      this.contractData.contactInformation.partyB.mail = selectedOption.email
    },
    quoteHandleSelectChange(value) {
      const selectedOption = this.quoteList.find(option => option.quote_no === value);
      this.contractData.quote.items = selectedOption.items
      this.contractData.quote.totalAmountCapital = selectedOption.total_amount_capital
      this.contractData.quote.totalAmount = selectedOption.total_amount
    },
    contactInformationHandleSelectChange(value) {
      const selectedOption = this.contactsList.find(option => option.id === value);
      //this.contractData.contactInformation.partyA.telephone = selectedOption.phone
      this.contractData.contactInformation.partyA.mail = selectedOption.mailbox
      this.contractData.contactInformation.partyA.name = selectedOption.name
      this.getContactPhoneA(this.contactsList,this.contractData.contactInformation.partyA.contact_id)
    },
    getCurrentDate() {
      const today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();

      // 格式化为yyyyMMdd
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }

      return year + "年" + month + "月" + day + "日";
    },
    setPartyDate(){
      this.contractData.partyA.date = this.getCurrentDate()
      this.contractData.partyB.date = this.getCurrentDate()
    },
    test(){

    },
    async getContactPhone(res,id){
      this.contactPhones = []
      for (let contact of res){
        if (contact.id === id){
          this.contractData.partyA.contacts = contact.name;
        }
      }
      let params = {contact_id:id}
      this.contactPhones = await this.$http('companyOrganization.getContactPhoneById',params);
      if(!this.buttonShow){
        return;
      }
      if(this.contactPhones.length > 0){
        this.contractData.partyA.telephone_id = this.contactPhones[0].id;
        this.contractData.partyA.telephone = this.contactPhones[0].phone
      }else {
        this.contractData.partyA.telephone_id = '';
        this.contractData.partyA.telephone = '';
      }
    },
    // getContactPhone(res,name){
    //   this.contactPhones = []
    //   let phone = ''
    //   res.forEach((item) => {
    //     if (item.name === name){
    //       phone = item.phone
    //     }
    //   })
    //   let phones = phone.split("/")
    //   phones.forEach((item => {
    //     if (item) {
    //       let data = {}
    //       data.id = item
    //       data.name = item
    //       this.contactPhones.push(data)
    //     }
    //   }))
    //   this.contractData.partyA.telephone = this.contactPhones[0].id
    // },
    async getContactPhoneA(res,id){
      this.contactPhonesA = []
      // let phone = ''
      // res.forEach((item) => {
      //   if (item.name === name){
      //     phone = item.phone
      //   }
      // })
      let params = {contact_id:id}
      this.contactPhonesA = await this.$http('companyOrganization.getContactPhoneById',params);
      if(!this.buttonShow){
        return;
      }
      if(this.contactPhonesA.length > 0){
        this.contractData.contactInformation.partyA.telephone_id = this.contactPhonesA[0].id
        this.contractData.contactInformation.partyA.telephone = this.contactPhonesA[0].phone
      }else {
        this.contractData.contactInformation.partyA.telephone_id = '';
        this.contractData.contactInformation.partyA.telephone = '';
      }
      // let phones = phone.split("/")
      // phones.forEach((item => {
      //   if (item) {
      //     let data = {}
      //     data.id = item
      //     data.name = item
      //     this.contactPhonesA.push(data)
      //   }
      // }))
      // this.contractData.contactInformation.partyA.telephone = this.contactPhonesA[0].id
    }
  },
  async created() {
    if (this.parentData.content_json){
      this.buttonShow = false ;
      let params = JSON.parse(this.parentData.content_json)
      this.contractData = null;
      this.contractData = {...params};
      this.contractData.partyA.address = params.partyA.address;

      await this.getFileUrl()
    }
    if(this.parentData.chance_id){
      await this.getContactByChanceId(this.parentData.chance_id)
      //await this.getQuoteByChanceId(this.parentData.chance_id)
    }
    if(this.contactsList && this.contractData.partyA.contact_id){
      await this.getContactPhone(this.contactsList,this.contractData.partyA.contact_id);
      await this.getContactPhoneA(this.contactsList,this.contractData.contactInformation.partyA.contact_id);
    }
    await this.getUserCompanyList();
    await this.getCurrentUserInfo()
    await this.getUserAll()
    await this.setPartyDate()
    await this.getSysCompany()
    await this.getUser()
    this.content = this.$store.state.core.currentUser?.full_name
  }
}
</script>

<style scoped>

.container {
  display: flex; /* 使用flex布局 */
  justify-content: space-between; /* 使用space-between来实现元素分散对齐 */
  align-items: center; /* 元素在交叉轴上居中对齐 */
}

.indent-text {
  text-indent: 22px;
}

.left {
  float: left;
  width: 22px; /* 将宽度设置为22px */
}
.right {
  float: left;
  width: calc(100% - 22px); /* 右边div的宽度为总宽度减去左边div的宽度 */
}

.el-table__body-wrapper::after {
  content: '';
  display: block;
  height: 1px;
  background-color: transparent; /* 将底部边框的颜色设置为跟背景一样的颜色，使其看起来像消失了 */
}


/deep/.el-input__wrapper{
  box-shadow: none;
  border-bottom: whitesmoke 3px solid;
}

/deep/.el-input.is-disabled .el-input__wrapper {
  background-color: transparent;
  box-shadow: none;
}

/deep/.el-select .el-input.is-disabled .el-input__inner {
  -webkit-text-fill-color: #4E7291;
}

/deep/.el-input.is-disabled .el-input__inner {
  -webkit-text-fill-color: #4E7291;
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #4E7291;
  background-color: transparent;
}
/deep/.el-select__wrapper {
  background-color: transparent;
  box-shadow: none;
  padding: unset;
}


</style>